import { FC } from 'react';
import { Plus } from 'lucide-react';
import { cn } from '@/lib/utils';

interface EmptyBatterySlotProps {
  size: 'single' | 'double';
}

export const EmptyBatterySlot: FC<EmptyBatterySlotProps> = ({ size }) => {
  const sizeClasses = {
    single: 'w-16 h-16',
    double: 'w-32 h-16',
  };

  return (
    <div
      className={cn(
        'border-2 border-dashed border-muted-foreground/20 rounded-lg',
        'flex items-center justify-center',
        'bg-muted/5',
        sizeClasses[size]
      )}
    >
      <Plus className="h-6 w-6 text-muted-foreground/30" />
    </div>
  );
};
